import * as React from 'react';

import { ContextProviderProps } from 'types/contextProviderProps';
import { FacilitySelectOption } from 'types/inputProps';

import { ActiveFacilityContext } from 'context/activeFacility';

const ActiveFacilityProvider = (props: ContextProviderProps): React.JSX.Element => {
  const storage: Pick<Storage, 'getItem' | 'setItem'> | null = typeof window !== 'undefined'
    ? window.sessionStorage
    : null;

  const [currentFacility, setCurrentFacility] = React.useState<FacilitySelectOption>({
    label: storage?.getItem('facilityName') ?? '',
    value: storage?.getItem('facilityID') ?? '',
    isCoreMeasures: storage?.getItem('facilityCM') === 'true',
    hasServiceCodes: storage?.getItem('facilitySVC') === 'true',
    pixDataEntry: storage?.getItem('facilityPIX') ?? '',
    isUHS: storage?.getItem('facilityUHS') === 'true',
    isOutcomes: storage?.getItem('facilityOutcomes') === 'true',
  });

  React.useEffect(() => {
    if (!storage) {
      return;
    }

    storage.setItem('facilityName', currentFacility.label);
    storage.setItem('facilityID', currentFacility.value);
    storage.setItem('facilityCM', currentFacility.isCoreMeasures ? 'true' : 'false');
    storage.setItem('facilitySVC', currentFacility.hasServiceCodes ? 'true' : 'false');
    storage.setItem('facilityPIX', currentFacility?.pixDataEntry ?? '');
    storage.setItem('facilityUHS', currentFacility.isUHS ? 'true' : 'false');
    storage.setItem('facilityOutcomes', currentFacility.isOutcomes ? 'true' : 'false');
  }, [currentFacility, storage]);

  return (
    <ActiveFacilityContext.Provider
      value={{
        facility: currentFacility,
        SwitchFacility: (option: FacilitySelectOption): void => {
          setCurrentFacility(option);
        },
      }}
    >
      {props.children}
    </ActiveFacilityContext.Provider>
  );
};

export default ActiveFacilityProvider;
